import { Fragment } from 'react'

export function Button ({ color, description, onClick }) {
    return (
        <Fragment>
            <button className={`transition duration-200 ring-2 ring-${color}-500 bg-white hover:bg-${color}-500 hover:text-white text-${color}-400 font-normal px-6 py-2 max-h-10 whitespace-nowrap cursor-pointer rounded`} onClick={onClick}>
                {description}
            </button>
        </Fragment>
    )
}